export default __webpack_public_path__ + "static/media/CNo.79-3.2d23acdb.jpg";